// 📁 components/PracticalSheet.tsx
import React from 'react';

export const PracticalSheet = ({
  title,
  icon = '🗂️',
  description,
  steps = [],
  relatedLinks = [],
}) => (
  <div className="p-4 rounded-2xl shadow-md bg-white border border-gray-200 max-w-xl">
    <h2 className="text-xl font-semibold mb-2">{icon} {title}</h2>
    <p className="mb-4 text-gray-700 text-sm">{description}</p>
    {steps.length > 0 && (
      <ol className="list-decimal list-inside space-y-1 mb-4 text-sm">
        {steps.map((step, idx) => <li key={idx}>{step}</li>)}
      </ol>
    )}
    {relatedLinks.length > 0 && (
      <div className="text-sm">
        <strong>Liens utiles :</strong>
        <ul className="list-disc list-inside">
          {relatedLinks.map((link, idx) => (
            <li key={idx}><a href={link.href} className="text-blue-600 underline">{link.label}</a></li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

// 📁 Exemple d'utilisation dans une page ou un composant parent
// import { PracticalSheet } from './components/PracticalSheet';

export const FichesExamples = () => (
  <div className="space-y-6">
    <PracticalSheet
      title="Ajouter une œuvre à votre collection"
      description="Découvrez comment enregistrer une œuvre d’art dans votre espace sécurisé Artkiv."
      steps={[
        'Accédez à votre tableau de bord.',
        'Cliquez sur “Ajouter une œuvre”.',
        'Remplissez les informations : titre, artiste, année, etc.',
        'Ajoutez des fichiers : photo, certificat, facture.',
        'Enregistrez et suivez sa valeur en temps réel.'
      ]}
      relatedLinks={[
        { label: 'Guide du catalogage', href: '/guides/catalogage' },
        { label: 'Assistance', href: '/support' }
      ]}
    />

    <PracticalSheet
      title="Demander une estimation en ligne"
      icon="💰"
      description="Faites estimer vos œuvres par notre IA combinée à notre réseau d’experts."
      steps={[
        'Sélectionnez l’œuvre concernée.',
        'Cliquez sur “Demander une estimation”.',
        'Renseignez les détails complémentaires si demandés.',
        'Recevez une estimation sous 48h.'
      ]}
    />
  </div>
);
